(function (root, factory) {
        if (typeof define === 'function' && define.amd) {
            // AMD. Register as an anonymous module.
            define([], factory);
        } else if (typeof module === 'object' && module.exports) {
            // Node. Does not work with strict CommonJS, but
            // only CommonJS-like environments that support module.exports,
            // like Node.
            module.exports = factory();
        } else {
            // Browser globals (root is window)
            root.returnExports = factory();
        }
    }(typeof self !== 'undefined' ? self : this, function () {
        // Just return a value to define the module export.
        // This example returns an object, but the module
        // can return a function as the exported value.
        'use strict';
        var skins = {};
         skins['wysiwyg.viewer.skins.ExpandableMenuSkin'] = {
  "react": [
    [
      "ul",
      "menuContainer",
      [],
      {},
      [
        "li",
        "menuItem",
        [
          "_item"
        ],
        {},
        [
          "div",
          null,
          [
            "_itemWrapper"
          ],
          {},
          [
            "span",
            null,
            [
              "_labelWrapper"
            ],
            {},
            [
              "a",
              null,
              [],
              {}
            ]
          ],
          [
            "span",
            null,
            [
              "_arrowWrapper"
            ],
            {},
            [
              "div",
              null,
              [
                "_arrow"
              ],
              {
                "tabIndex": 0,
                "role": "tree"
              },
              [
                "svg",
                null,
                [],
                {
                  "xmlns": "http://www.w3.org/2000/svg",
                  "viewBox": "0 0 9.2828 4.89817"
                },
                [
                  "path",
                  null,
                  [],
                  {
                    "d": "M4.64116,4.89817a.5001.5001,0,0,1-.34277-.13574L.15727.86448A.50018.50018,0,0,1,.84282.136L4.64116,3.71165,8.44.136a.50018.50018,0,0,1,.68555.72852L4.98393,4.76243A.5001.5001,0,0,1,4.64116,4.89817Z"
                  }
                ]
              ]
            ]
          ]
        ],
        [
          "ul",
          null,
          [
            "_subMenu"
          ],
          {}
        ]
      ]
    ]
  ],
  "exports": {
    "menuContainer": {
      "dontMergeParams": true
    }
  },
  "params": {
    "bgs": "BORDER_COLOR_ALPHA",
    "itemBGColorNoTrans": "TRANSITION",
    "shd": "BOX_SHADOW",
    "bg": "BG_COLOR_ALPHA",
    "brw": "BORDER_SIZES",
    "brd": "BORDER_COLOR_ALPHA",
    "itemBGColorTrans": "TRANSITION",
    "fnt": "FONT",
    "txt": "TEXT_COLOR",
    "arrowColor": "TEXT_COLOR",
    "subMenuOpacityTrans": "TRANSITION",
    "bgsSub": "BORDER_COLOR_ALPHA",
    "txtsSub": "TEXT_COLOR",
    "txts": "TEXT_COLOR",
    "bgexpanded": "BORDER_COLOR_ALPHA",
    "fntSubMenu": "FONT",
    "txtexpanded": "TEXT_COLOR",
    "subMenuSpacing": "PADDING_SIZE",
    "menuSpacing": "PADDING_SIZE"
  },
  "paramsDefaults": {
    "bgs": "color_15",
    "itemBGColorNoTrans": "background-color 50ms ease 0s",
    "shd": "0 1px 4px rgba(0, 0, 0, 0.6)",
    "bg": "color_11",
    "brw": "1px",
    "brd": "color_15",
    "itemBGColorTrans": "background-color 0.4s ease 0s",
    "fnt": "font_1",
    "txt": "color_15",
    "arrowColor": "color_15",
    "subMenuOpacityTrans": "all 0.4s ease 0s",
    "bgsSub": "color_15",
    "txtsSub": "color_13",
    "txts": "color_13",
    "bgexpanded": "color_15",
    "fntSubMenu": "font_1",
    "txtexpanded": "color_13",
    "subMenuSpacing": "10px",
    "menuSpacing": "10px"
  },
  "css": {
    "% > ul": "width:100%;box-sizing:border-box;",
    "% > ul li": "display:table;table-layout:fixed;width:100%;min-height:50px;",
    "% > ul li:focus,% > ul li:active": "background-color:[bgs];[itemBGColorNoTrans]",
    "%menuContainer": "padding:0;margin:0;width:100%;height:100%;position:relative;[shd]",
    "%menuContainer %_emptySubMenu": "display:none;",
    "%_item": "background-color:[bg];margin:0;position:relative;display:-webkit-box;display:-webkit-flex;display:flex;cursor:pointer;list-style:none;box-sizing:border-box;min-width:100px;[brw]  border-color:[brd];border-style:solid;[itemBGColorTrans]",
    "%_item %_itemWrapper": "position:relative;display:-webkit-box;display:-webkit-flex;display:flex;",
    "%_item %_itemWrapper > %_labelWrapper": "-webkit-box-flex:1;-webkit-flex-grow:1;flex-grow:1;overflow:hidden;text-overflow:ellipsis;",
    "%_item %_itemWrapper > %_labelWrapper > %_label": "-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;[fnt]        color:[txt];display:inline;white-space:nowrap;overflow:hidden;",
    "%_item %_itemWrapper > %_arrowWrapper": "display:none;opacity:0;min-width:12px;padding-left:20px;padding-right:20px;",
    "%_item %_itemWrapper > %_arrowWrapper > %_arrow": "min-width:12px;width:1em;",
    "%_item %_itemWrapper > %_arrowWrapper > %_arrow svg": "pointer-events:none;fill:[arrowColor];",
    "%_item%_hasSubList > %_itemWrapper > %_arrowWrapper": "display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;opacity:1;",
    "%_item%_hasSubList > %_itemWrapper > %_labelWrapper": "overflow:hidden;text-overflow:ellipsis;max-width:calc(100% - 40px - 1em);",
    "%_item%_expanded %_arrow": "-webkit-transform:rotate(180deg);transform:rotate(180deg);",
    "%_item%_expanded %_subMenu": "opacity:1;[subMenuOpacityTrans]    display:block;",
    "%_item%_selected > %_itemWrapper": "background-color:[bgs];",
    "%_hasSubList %_item%_selected > %_itemWrapper": "background-color:[bgsSub];",
    "%_item%_selected > %_itemWrapper > %_labelWrapper > %_label": "color:[txtsSub];color:[txts];",
    "%_item > %_subMenu": "opacity:0;[subMenuOpacityTrans]    display:none;min-width:100%;",
    "%_item > %_subMenu > %_item": "background-color:[bgexpanded];border:none;",
    "%_item > %_subMenu > %_item %_label": "[fntSubMenu]        color:[txtexpanded];",
    "%[data-state~=\"items-align-left\"] %_item%_hasSubList > %_itemWrapper > %_arrowWrapper,%[data-state~=\"items-align-right\"] %_item%_hasSubList > %_itemWrapper > %_arrowWrapper": "position:initial;",
    "%[data-state~=\"items-align-left\"] %_item": "text-align:left;",
    "%[data-state~=\"items-align-left\"] %_item > %_subMenu > %_item > %_itemWrapper > %_labelWrapper": "padding-left:[subMenuSpacing];",
    "%[data-state~=\"items-align-left\"] %_item %_itemWrapper > %_labelWrapper": "padding-left:[menuSpacing];",
    "%[data-state~=\"items-align-right\"] %_item": "text-align:right;",
    "%[data-state~=\"items-align-right\"] %_item > %_subMenu > %_item > %_itemWrapper > %_labelWrapper": "padding-right:[subMenuSpacing];",
    "%[data-state~=\"items-align-right\"] %_item %_itemWrapper > %_labelWrapper": "padding-right:[menuSpacing];",
    "%[data-state~=\"items-align-center\"] %_item": "text-align:center;",
    "%[data-state~=\"items-align-center\"] %_item%_hasSubList > %_itemWrapper": "-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;flex-direction:row-reverse;",
    "%[data-state~=\"items-align-center\"] %_item%_hasSubList > %_itemWrapper > %_labelWrapper": "margin:0 calc(40px + 1em);",
    "%[data-state~=\"items-align-center\"] %_arrowWrapper": "position:absolute;top:0;right:0;height:100%;",
    "%[data-state~=\"items-align-center\"][data-state~=\"arrow-direction-left\"] %_item %_itemWrapper > %_arrowWrapper": "left:0;right:initial;",
    "%[data-state~=\"arrow-direction-left\"] %_item %_itemWrapper": "direction:rtl;"
  }
}
 skins['wysiwyg.viewer.skins.ResponsiveExpandableMenuSkin'] = {
  "react": [
    [
      "ul",
      "menuContainer",
      [],
      {},
      [
        "li",
        "menuItem",
        [
          "_item"
        ],
        {},
        [
          "div",
          null,
          [
            "_itemWrapper"
          ],
          {},
          [
            "span",
            null,
            [
              "_labelWrapper"
            ],
            {},
            [
              "a",
              null,
              [],
              {}
            ]
          ],
          [
            "span",
            null,
            [
              "_arrowWrapper"
            ],
            {},
            [
              "div",
              null,
              [
                "_arrow"
              ],
              {
                "tabIndex": 0,
                "role": "tree"
              },
              [
                "svg",
                null,
                [],
                {
                  "xmlns": "http://www.w3.org/2000/svg",
                  "viewBox": "0 0 9.2828 4.89817"
                },
                [
                  "path",
                  null,
                  [],
                  {
                    "d": "M4.64116,4.89817a.5001.5001,0,0,1-.34277-.13574L.15727.86448A.50018.50018,0,0,1,.84282.136L4.64116,3.71165,8.44.136a.50018.50018,0,0,1,.68555.72852L4.98393,4.76243A.5001.5001,0,0,1,4.64116,4.89817Z"
                  }
                ]
              ]
            ]
          ]
        ],
        [
          "ul",
          null,
          [
            "_subMenu"
          ],
          {}
        ]
      ]
    ]
  ],
  "exports": {
    "menuContainer": {
      "dontMergeParams": true
    }
  },
  "params": {
    "bgs": "BORDER_COLOR_ALPHA",
    "itemBGColorNoTrans": "TRANSITION",
    "shd": "BOX_SHADOW",
    "bg": "BG_COLOR_ALPHA",
    "brw": "BORDER_SIZES",
    "brd": "BORDER_COLOR_ALPHA",
    "itemBGColorTrans": "TRANSITION",
    "verticalPadding": "PADDING_SIZE",
    "fnt": "FONT",
    "txt": "TEXT_COLOR",
    "arrowColor": "TEXT_COLOR",
    "subMenuOpacityTrans": "TRANSITION",
    "bgsSub": "BORDER_COLOR_ALPHA",
    "txtsSub": "TEXT_COLOR",
    "txts": "TEXT_COLOR",
    "bgexpanded": "BORDER_COLOR_ALPHA",
    "fntSubMenu": "FONT",
    "txtexpanded": "TEXT_COLOR",
    "subMenuSpacing": "PADDING_SIZE",
    "menuSpacing": "PADDING_SIZE"
  },
  "paramsDefaults": {
    "bgs": "color_15",
    "itemBGColorNoTrans": "background-color 50ms ease 0s",
    "shd": "0 1px 4px rgba(0, 0, 0, 0.6)",
    "bg": "color_11",
    "brw": "1px",
    "brd": "color_15",
    "itemBGColorTrans": "background-color 0.4s ease 0s",
    "verticalPadding": "0",
    "fnt": "font_1",
    "txt": "color_15",
    "arrowColor": "color_15",
    "subMenuOpacityTrans": "all 0.4s ease 0s",
    "bgsSub": "color_15",
    "txtsSub": "color_13",
    "txts": "color_13",
    "bgexpanded": "color_15",
    "fntSubMenu": "font_1",
    "txtexpanded": "color_13",
    "subMenuSpacing": "10px",
    "menuSpacing": "10px"
  },
  "css": {
    "%": "display:grid;grid-template-columns:minmax(0, 1fr);",
    "% > ul": "box-sizing:border-box;",
    "% > ul li": "width:100%;",
    "% > ul li:focus,% > ul li:active": "background-color:[bgs];[itemBGColorNoTrans]",
    "%menuContainer": "padding:0;margin:0;width:100%;height:100%;position:relative;[shd]",
    "%menuContainer %_emptySubMenu": "display:none;",
    "%_item": "background-color:[bg];margin:0;position:relative;cursor:pointer;list-style:none;box-sizing:border-box;[brw]  border-color:[brd];border-style:solid;[itemBGColorTrans]",
    "%_item %_itemWrapper": "position:relative;display:-webkit-box;display:-webkit-flex;display:flex;width:100%;padding-top:[verticalPadding];padding-bottom:[verticalPadding];",
    "%_item %_itemWrapper > %_labelWrapper": "-webkit-box-flex:1;-webkit-flex-grow:1;flex-grow:1;overflow:hidden;text-overflow:ellipsis;",
    "%_item %_itemWrapper > %_labelWrapper > %_label": "-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;[fnt]        color:[txt];display:inline;white-space:nowrap;",
    "%_item %_itemWrapper > %_arrowWrapper": "display:none;opacity:0;width:12px;padding-left:20px;padding-right:20px;",
    "%_item %_itemWrapper > %_arrowWrapper > %_arrow svg": "pointer-events:none;fill:[arrowColor];",
    "%_item%_hasSubList > %_itemWrapper > %_arrowWrapper": "display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;opacity:1;",
    "%_item%_hasSubList > %_itemWrapper > %_labelWrapper": "max-width:calc(100% - 40px - 1em);",
    "%_item%_expanded %_arrow": "-webkit-transform:rotate(180deg);transform:rotate(180deg);",
    "%_item%_expanded %_subMenu": "opacity:1;[subMenuOpacityTrans]    display:block;",
    "%_item%_selected > %_itemWrapper": "background-color:[bgs];",
    "%_hasSubList %_item%_selected > %_itemWrapper": "background-color:[bgsSub];",
    "%_item%_selected > %_itemWrapper > %_labelWrapper > %_label": "color:[txtsSub];color:[txts];",
    "%_item > %_subMenu": "opacity:0;[subMenuOpacityTrans]    display:none;width:100%;",
    "%_item > %_subMenu > %_item": "background-color:[bgexpanded];border:none;",
    "%_item > %_subMenu > %_item %_label": "[fntSubMenu]        color:[txtexpanded];",
    "%[data-state~=\"items-align-left\"] %_item": "text-align:left;",
    "%[data-state~=\"items-align-left\"] %_item > %_subMenu > %_item > %_itemWrapper > %_labelWrapper": "padding-left:[subMenuSpacing];",
    "%[data-state~=\"items-align-left\"] %_item %_itemWrapper > %_labelWrapper": "padding-left:[menuSpacing];",
    "%[data-state~=\"items-align-right\"] %_item": "text-align:right;",
    "%[data-state~=\"items-align-right\"] %_item > %_subMenu > %_item > %_itemWrapper > %_labelWrapper": "padding-right:[subMenuSpacing];",
    "%[data-state~=\"items-align-right\"] %_item %_itemWrapper > %_labelWrapper": "padding-right:[menuSpacing];",
    "%[data-state~=\"items-align-center\"] %_item": "text-align:center;",
    "%[data-state~=\"items-align-center\"] %_item%_hasSubList > %_itemWrapper": "-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;flex-direction:row-reverse;",
    "%[data-state~=\"items-align-center\"] %_item%_hasSubList > %_itemWrapper > %_labelWrapper": "margin-left:calc(40px + 1em);margin-right:calc(40px + 1em);",
    "%[data-state~=\"items-align-center\"] %_arrowWrapper": "position:absolute;top:0;right:0;height:100%;",
    "%[data-state~=\"items-align-center\"][data-state~=\"arrow-direction-left\"] %_item %_itemWrapper > %_arrowWrapper": "left:0;right:initial;",
    "%[data-state~=\"arrow-direction-left\"] %_item %_itemWrapper": "direction:rtl;"
  }
}

        return skins;
    }));